module.exports = __webpack_public_path__ + "media/images/WHATSAPP-f3b81e9c5310d28d5b6dcb1a9c2a9cfc.png";